import { Environments } from '@/config';
import { SANFORD_PRODUCTION } from './sanford.production';
import { SANFORD_STAGING } from './sanford.staging';

export const SANFORD = import.meta.env.MODE === Environments.PROD ? SANFORD_PRODUCTION : SANFORD_STAGING;
